<template>
  <section
    :class="[
      accordionLayout === 'single' ? '' : 'py-20',
      accordionLayout !== 'single' && (backgroundGreen ? 'bg-br-green-light' : 'bg-putty'),
    ]"
  >
    <div v-if="accordionLayout !== 'single'" class="container max-w-screen-md mx-auto">
      <h2 class="fluid-3xl leading-tightest mb-4 text-center">{{ heading || $t('shop.accordionHeading') }}</h2>
    </div>
    <div class="container max-w-screen-md mx-auto">
      <Disclosure
        v-for="(panel, index) in resolvedAccordions"
        :key="index"
        as="div"
        class="border-b border-gray-400"
        v-slot="{ open }"
      >
        <DisclosureButton
          class="fluid-base py-3 flex items-center justify-between w-full leading-relaxed font-light text-left"
        >
          <span class="pr-2 text-wrap">
            {{ panel.accordionTitle }}
          </span>
          <RemoveIcon v-if="open" class="h-6 shrink-0" />
          <AddIcon v-else class="h-6 shrink-0" />
        </DisclosureButton>
        <div class="grid transition-all duration-300 ease-in-out" :style="{ gridTemplateRows: open ? '1fr' : '0fr' }">
          <DisclosurePanel static class="overflow-hidden">
            <div class="fluid-base leading-relaxed font-light text-copy pt-2 pb-8" v-html="panel.body"></div>
          </DisclosurePanel>
        </div>
      </Disclosure>
    </div>
  </section>
</template>

<script setup>
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue';
import AddIcon from '@/components/icons/AddIcon';
import RemoveIcon from '@/components/icons/RemoveIcon';
import { generateSchema as generateAccordionSchema } from './Accordion.schema';
import { useSchema } from '@/composables/useSchema';

const props = defineProps({
  heading: {
    type: String,
    default: '',
  },
  backgroundGreen: {
    type: Boolean,
    default: false,
  },
  accordionLayout: {
    type: String,
    default: 'block',
    validator: (value) => ['block', 'single'].includes(value),
  },
  accordions: {
    type: Array,
    default: () => [],
  },
  useShopifyData: {
    type: Boolean,
    default: false,
  },
  useSchemaOrg: {
    type: Boolean,
    default: false,
  },

  product: {
    type: Object,
    default: null,
  },
});

if (props.useSchemaOrg && props.accordions?.length > 0) {
  const { registerComponentSchema } = useSchema();
  const schema = generateAccordionSchema(props);
  registerComponentSchema(schema, 'accordion-block');
}

const resolvedAccordions = computed(() => {
  if (!props.useShopifyData) {
    return props.accordions;
  }

  return (
    props.product?.accordion?.map((f) => ({
      accordionTitle: f.title,
      body: f.description,
    })) || []
  );
});

// Define schema type for the component
defineOptions({
  schemaType: 'Accordion',
});
</script>
